import TenantPage from 'layouts/TenantPage';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { requestDepartmentLaboratoryService } from 'shared/services';
import toast from 'shared/utils/toast';
import RequestDepartmentTranscodeForm from '../components/RequestDepartmentTranscodeForm';
import { IRequestDepartmentTranscode } from '../types';

export const EditRequestDepartmentTranscode = () => {
  const { t } = useTranslation();
  const translationPrefix = 'pages.request-dep-lab.new';

  const { typeId } = useParams();
  const [transcode, setTranscode] = useState<IRequestDepartmentTranscode>();

  useEffect(() => {
    requestDepartmentLaboratoryService.get(+typeId).then(setTranscode);
  }, []);

  const updateType = async (values) => {
    requestDepartmentLaboratoryService.update(transcode.id, values).then((res) => {
      toast.success('Tipo aggiunto con successo');
    });
  };

  return (
    <TenantPage
      title={t(`${translationPrefix}.title`)}
      subtitle={t(`${translationPrefix}.subtitle`)}
      entityCode={transcode?.department}>
      <RequestDepartmentTranscodeForm transcode={transcode} onSubmit={updateType} />
    </TenantPage>
  );
};

export default EditRequestDepartmentTranscode;
